import { render, staticRenderFns } from "./ModalExcluirCamera.vue?vue&type=template&id=adeac212&scoped=true"
import script from "./ModalExcluirCamera.vue?vue&type=script&lang=js"
export * from "./ModalExcluirCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adeac212",
  null
  
)

export default component.exports